import type { CompletionContext, CompletionResult } from '@codemirror/autocomplete';
import { listDocumentMeta } from '../lib/docMeta';

/**
 * CodeMirror completion source for wiki-links: typing `[[` offers existing
 * document titles and inserts `Title]]`. Registered alongside the slash-snippet
 * source in the editor's `autocompletion` override.
 */
export async function wikiCompletions(ctx: CompletionContext): Promise<CompletionResult | null> {
  const before = ctx.matchBefore(/\[\[([^\]\n]*)$/);
  if (!before) return null;
  const typed = before.text.slice(2); // text after the "[["
  if (!ctx.explicit && typed.length === 0) return null;

  // Metadata only: completing a title must not read every document's body.
  const docs = await listDocumentMeta();
  const q = typed.toLowerCase();
  const options = docs
    .flatMap((d) => [d.title || 'Untitled', ...d.aliases])
    .filter((title) => title.toLowerCase().includes(q))
    .slice(0, 20)
    .map((title) => ({ label: title, type: 'text', apply: `${title}]]` }));
  if (options.length === 0) return null;

  return { from: before.from + 2, options };
}
